import { useCallback } from 'react';
import { ApiError, problemReportsApi } from '@/lib/api';
import { useAuthedFetcher } from '@/hooks/queries/swrConfig';
import type { CreateProblemReportRequest } from '@/types';

export type ProblemReportSubmitOutcome = { ok: true } | { ok: false; message: string };

const GENERIC_ERROR = 'Não foi possível enviar seu relato. Tente novamente.';

export function useProblemReportSubmit() {
  const authedFetch = useAuthedFetcher();

  return useCallback(
    async (data: CreateProblemReportRequest): Promise<ProblemReportSubmitOutcome> => {
      try {
        await authedFetch((token) => problemReportsApi.create(token, data));
        return { ok: true };
      } catch (err) {
        // 502/503 mean Linear filing failed; nothing was persisted server-side.
        // Surface the error so the user can retry (their draft is preserved client-side).
        const message = err instanceof ApiError && err.message ? err.message : GENERIC_ERROR;
        return { ok: false, message };
      }
    },
    [authedFetch],
  );
}
